import { render } from "./VagasCarousel.vue?vue&type=template&id=568a4c42&scoped=true"
import script from "./VagasCarousel.vue?vue&type=script&lang=js"
export * from "./VagasCarousel.vue?vue&type=script&lang=js"

import "./VagasCarousel.vue?vue&type=style&index=0&id=568a4c42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568a4c42"]])

export default __exports__